import { useEffect } from 'react';
import './Tile.css';
import { DailyVideo, useActiveSpeakerId, useVideoTrack } from '@daily-co/daily-react';
import Username from '../Username/Username';

export default function Tile({
  id,
  isScreenShare = false,
  isLocal,
  isTeacher,
  isLast = false,
  hasNextTile = false,
}) {
  const videoState = useVideoTrack(id);
  const activeSpeakerId = useActiveSpeakerId();

  let containerCssClasses = isScreenShare ? 'tile-screenshare' : 'tile-video';

  if (isTeacher) {
    containerCssClasses += ' self-view';
    if (isTeacher) {
      containerCssClasses += ' alone';
    }
  }

  if (!isScreenShare && videoState.isOff) {
    containerCssClasses += ' no-video';
  }

  useEffect(() => {}, [activeSpeakerId]);
  if (activeSpeakerId === id) {
    containerCssClasses += ' active-speaker';
  }

  if (isLast && hasNextTile) {
    return (
      <div className="tile-fade">
        <div className={containerCssClasses}>
          <DailyVideo
            style={{ aspectRatio: '16/9' }}
            fit={isTeacher ? 'contain' : 'contain'}
            automirror
            sessionId={id}
            type={isScreenShare ? 'screenVideo' : 'video'}
          />
          <Username id={id} isLocal={isLocal} />
        </div>
        <div className="fade-overlay" />
      </div>
    );
  }

  return (
    <div className={containerCssClasses}>
      <DailyVideo
        style={{ aspectRatio: '16/9' }}
        fit={isTeacher ? 'contain' : 'contain'}
        automirror
        sessionId={id}
        type={isScreenShare ? 'screenVideo' : 'video'}
      />
      <Username id={id} isLocal={isLocal} />
    </div>
  );
}
